import { TenantConfig } from '../types';

const disclaimer = `# Willkommen beim KI-Info-Assistenten
Dies ist ein KI-gestützter Info-Assistent, der Fragen zu den Produkten *Opzelura*, *Iclusig*, *Pemazyre* und *Minjuvi* beantwortet. Bitte überprüfen Sie die Quellen, wenn Sie sich bei der Antwort unsicher sind.  
Um fortzufahren, bestätigen Sie die folgende Einwilligung:\n- Ich bestätige, dass ich mindestens 18 Jahre alt bin und stimme hiermit der Verarbeitung aller personenbezogenen Daten (einschließlich Gesundheitsdaten), die ich hier im Rahmen der Anfrage freiwillig angebe, zum Zwecke der Beantwortung meiner Anfrage zu. Ich kann meine Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen.\n- Ich stimme den <code>Allgemeinen Nutzungsbedingungen</code> zu.\n- Ich bestätige außerdem, dass es sich bei meiner Anfrage um eine allgemeine medizinische Frage handelt, die keine Nebenwirkungen beinhaltet.`;

const terms = `Die auf dieser Site bereitgestellten Inhalte basieren auf gültigen medizinischen Informationen und werden regelmäßig aktualisiert. Sie dient ausschließlich zu Informationszwecken und stellt keine patientenspezifische medizinische oder produktbezogene Empfehlung oder Beurteilung dar. Die hier bereitgestellten Inhalte sind kein Ersatz für eine ärztliche Untersuchung oder Erklärung und stellen keine Informationen über eine medizinische Diagnose oder Behandlung dar. Bitte kontaktieren Sie umgehend Ihren Arzt, wenn Sie medizinischen Rat benötigen.`;

const medicalInfo = `Medizinische Anfragen oder Meldungen zu unerwünschten Ereignissen können jederzeit über die folgenden Kontaktdaten gemeldet werden.\n\nIncyte Biosciences  \nMedical Information Center  \nTel: [+49 (0) 800 100 96 33](tel:+498001009633)  \nE-Mail: [eumedinfo@incyte.com](mailto:eumedinfo@incyte.com)\n\n[Weitere Informationen](https://incyte.com/contact-us/medical-information)`;

export const incyteConfig: TenantConfig = {
  id: 'incyte',
  label: 'Incyte',
  deploymentTargets: {
    dev: 'https://incyte-app-dev.xircle.com',
    staging: 'https://incyte-app-staging.xircle.com',
    prod: 'https://incyte-app.xircle.com',
  },
  instances: [
    {
      id: 'incyte',
      label: 'Incyte',
      i18nNamespace: 'incyte',
      themeName: 'incyte',
      topics: [],
      isDefault: true,
      consentStorage: 'local',
      useMaxHeight: false,
      theme: {
        tokens: {
          main: '240 50% 40%',
          secondary: '245 53% 57.5%',
          soft: '197 100% 46.9%',
        },
        classes: {
          layout: {
            container: 'font-open-sans rounded',
            headerTitle: 'text-[26px] font-bold',
            headerSubtitle: 'font-bold',
          },
          chat: {
            userMessage: 'text-[16px]',
            responseMessage: 'text-[16px]',
          },
        },
      },
      content: {
        disclaimer,
        terms,
        medicalInfo,
      },
    },
    {
      id: 'onko',
      label: 'Onko',
      i18nNamespace: 'incyte_onko',
      themeName: 'onko',
      topics: ['iclusig', 'pemazyre', 'minjuvi'],
      isDefault: false,
      consentStorage: 'local',
      useMaxHeight: false,
      theme: {
        tokens: {
          main: '188 100% 19%',
          secondary: '183 100% 33.9%',
          soft: '188 36.3% 39.4%',
        },
        classes: {
          layout: {
            container: 'font-open-sans rounded',
            headerTitle: 'text-[26px] font-bold',
            headerSubtitle: 'font-bold',
          },
          chat: {
            userMessage: 'text-[16px] text-[#005462] bg-white',
            responseMessage: 'text-[16px] text-black',
            followUpButton: 'text-black/90 bg-[#bdc6d2] hover:text-white/90',
            alternativeButton: 'bg-[#00a5ae]',
            thumbsDown: 'text-red-700 hover:text-red-400',
          },
        },
      },
      content: {
        disclaimer,
        terms,
        medicalInfo,
      },
    },
    {
      id: 'derma',
      label: 'Derma',
      i18nNamespace: 'incyte_derma',
      themeName: 'derma',
      topics: ['opzelura'],
      isDefault: false,
      consentStorage: 'local',
      useMaxHeight: false,
      theme: {
        tokens: {
          main: '188 100% 19%',
          secondary: '183 100% 33.9%',
          soft: '188 36.3% 39.4%',
        },
        classes: {
          layout: {
            container: 'font-open-sans rounded',
            headerTitle: 'text-[26px] font-bold',
            headerSubtitle: 'font-bold',
          },
          chat: {
            userMessage: 'text-[16px] text-[#005462] bg-white',
            responseMessage: 'text-[16px] text-black',
            followUpButton: 'bg-[#bdc6d2]',
            alternativeButton: 'bg-[#00a5ae]',
            thumbsDown: 'text-red-700 hover:text-red-400',
          },
        },
      },
      content: {
        disclaimer,
        terms,
        medicalInfo,
      },
    },
  ],
};
